var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4952_10034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.305908 16.1191L15.6941 16.1191",
    stroke: "currentColor",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4326 2.59134L12.8306 4.97251M5.07896 12.6698C4.80013 11.4515 3.85209 10.5101 2.62522 10.2332M4.91166 12.8359L1.84448 13.445L2.45792 10.3994L11.8468 1.22081C12.5718 0.500925 12.8863 1.04082 13.6113 1.7607C14.3363 2.48059 14.88 2.79296 14.155 3.51285L4.91166 12.8359Z",
    stroke: "currentColor",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4952_10034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cc043f0624977cc62b1bcb63f1fab6f8.svg";
export { ForwardRef as ReactComponent };